import { render, staticRenderFns } from "./ValidationError.vue?vue&type=template&id=0a5bbd62&scoped=true"
import script from "./ValidationError.vue?vue&type=script&lang=js"
export * from "./ValidationError.vue?vue&type=script&lang=js"
import style0 from "./ValidationError.vue?vue&type=style&index=0&id=0a5bbd62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5bbd62",
  null
  
)

export default component.exports